import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showDashIfNull'
})
export class ShowDashIfNullPipe implements PipeTransform {
  transform(value: any): any {
    return !value ? '-' : value;
  }
}
